import { render, staticRenderFns } from "./EditProductMeta.vue?vue&type=template&id=3189d7dc"
import script from "./EditProductMeta.vue?vue&type=script&lang=js"
export * from "./EditProductMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports